import React from 'react';
import { Button, Group } from '@economic/taco';
import { Trans } from '@lingui/macro';
import FileUploadButton from '~/app/shared/components/FileUploadButton';
import * as inapphelpMixpanel from '~/app/components/Header/Help/tracking';

export function AttachFilesAndScreenshots(): React.JSX.Element {
    function handleFileUpload(files: FileList | null) {
        console.log('handleFileUpload', files);

        inapphelpMixpanel.trackMail({ action: 'from-computer' });
    }

    function takeScreenshot() {
        console.log('takeScreenshot');

        inapphelpMixpanel.trackMail({ action: 'take-screenshot' });
    }

    return (
        <>
            <div className="p-4 flex flex-col items-center text-center gap-2 rounded border-grey-200 border-dashed border-2">
                <h2 className="m-0">
                    <Trans>Attach a file</Trans>
                </h2>
                <Group>
                    <Button onClick={takeScreenshot} appearance="default">
                        <Trans>Take screenshot</Trans>
                    </Button>
                    <FileUploadButton onFileSelect={handleFileUpload} appearance="default" fileInputKey={0}>
                        <Trans>From computer</Trans>
                    </FileUploadButton>
                </Group>
                <div>
                    <p className="text-grey-700 m-0">
                        <Trans>or drag a file to here (PDF, JPG, PNG, GIF)</Trans>
                        <br />
                        <Trans>Max file size: 9 MB</Trans>
                    </p>
                </div>
            </div>
            <p className="mt-4">
                <Trans>We will send you a copy of your request and respond to your mail within 48 hours</Trans>
            </p>
        </>
    );
}
